interface WatermarkProps {
  text: string
}

/**
 * Marca de agua de los documentos que no son el final (borrador, prueba).
 * `position: fixed` es lo que hace que Chromium la repita en cada página al
 * imprimir; en el preview del navegador queda sobre la primera vista.
 */
export const Watermark = ({ text }: WatermarkProps) => (
  <div
    aria-hidden
    style={{
      position: 'fixed',
      inset: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      pointerEvents: 'none',
      zIndex: 0,
    }}
  >
    <span
      style={{
        transform: 'rotate(-30deg)',
        fontSize: '64pt',
        fontWeight: 700,
        letterSpacing: '0.1em',
        color: 'rgba(24, 24, 27, 0.08)',
        whiteSpace: 'nowrap',
      }}
    >
      {text}
    </span>
  </div>
)
